exports.KAFKAKEYS = {
  // topics for database operations
  ADMIN_DATABASE_OPERATIONS: 'admindbo',
  CHAT_DATABASE_OPERATIONS: 'chatdbo',
  HOTEL_DATABASE_OPERATIONS: 'hoteldbo',
  MEDIAPROCESS_DATABASE_OPERATIONS: 'mediaprocessdbo',
  NOTIFICATION_DATABASE_OPERATIONS: 'notificationdbo',
  TASK_DATABASE_OPERATIONS: 'taskdbo',
  USER_DATABASE_OPERATIONS: 'userdbo',

  // topics for service executions
  ADMIN_SERVICE_EXECUTION: 'adminsvo',
  CHAT_SERVICE_EXECUTION: 'chatsvo',
  HOTEL_SERVICE_EXECUTION: 'hotelsvo',
  MEDIAPROCESS_SERVICE_EXECUTION: 'mediaprocesssvo',
  NOTIFICATION_SERVICE_EXECUTION: 'notificationsvo',
  TASK_SERVICE_EXECUTION: 'tasksvo',
  USER_SERVICE_EXECUTION: 'usersvo',

  // topic keys db
  FINDONE: 'findOne',
  FINDALL: 'find',
  FIND_ONE_AND_UPDATE: 'findOneAndUpdate',
  FIND_AND_UPDATE_MANY: 'findAndUpdateMany',
  DELETE_ONE: 'deleteOne',
  DEACTIVATE_ONE: 'deactivateOne',
  UPDATE_OR_CREATE: 'updateOrCreate',
  DELETE_MANY: 'deleteMany',
  INSERT: 'save',
  INSERT_MANY: 'saveMany',
  CREATE_AND_INSERT: 'createAndInsert',
  FIND_AND_CREATE: 'findAndCreate',
  FIND_AND_CREATE_USER: 'findAndCreateUser',
  FIND_ONE_AND_UPDATE_USER: 'findOneAndUpdateUser',
  FIND_ONE_AND_UPDATE_USER_TOKEN: 'findOneAndUpdateUserTokenBuilder',

  //topic keys service
  MEDIAPROCESS: 'mediaprocess',
  NOTIFICATION: 'notification',
};
